<template>
  <v-container fluid class="pa-0">
    <v-container class="pa-0 app" v-if="pageItemData.formData && shouldShowForm">
      <v-row class="pa-0">
         <v-col cols="12" sm="6">
          <VuetifyRender :html="introOneData"></VuetifyRender>
        </v-col>
        <v-col cols="12" sm="6">
          <JSONForm :formData="pageItemData.formData" />
        </v-col>
      </v-row>
    </v-container>
    <span v-else class="pa-0 app bg-pink">
      <VuetifyRender v-if="!renderError" class="pa-0" :html="introOneData" @error="handleRenderError"></VuetifyRender>
    </span>


  </v-container>
</template>

<script setup>
import JSONForm from "@/components/JSONForm/form.vue";
import { onErrorCaptured } from 'vue';
const dataAll = useDataAll();

const props = defineProps({
  pageItem: {
    type: Object,
    default: {},
  },
  introOne: {
    type: String,
    default: "",
  },
  showForm: {
    type: Boolean,
    default: true,
  },
});
// check for extra security to show form
const shouldShowForm = computed(() => {
  return props.showForm !== false;
});
const pageItemData = props.pageItem;

let introOneData = props.introOne;

const { PUBLIC_DATA_URL } = useRuntimeConfig().public
const isDev = process.env.NODE_ENV !== 'production'

// Replace /PUBLIC with PUBLIC_DATA_URL in development environment to load icons correctly from bucket
if (isDev){
  introOneData = introOneData.replaceAll("/PUBLIC", PUBLIC_DATA_URL)
}

const renderError = ref(false);

const handleRenderError = (err) => {
  renderError.value = true;

  console.log(err);
};

onErrorCaptured((error) => {
  renderError.value = true;
  console.log('Component error caught:', error);
  return false;
});
</script>
